import React, { useState } from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { Testimonials } from '../components/Testimonials';
import { PainPoints } from '../components/PainPoints';
import { Audience } from '../components/Audience';
import { Contents } from '../components/Contents';
import { ComparisonTable } from '../components/ComparisonTable';
import { Pricing } from '../components/Pricing';
import { ProPack } from '../components/ProPack';
import { Guarantee } from '../components/Guarantee';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { PurchaseNotification } from '../components/PurchaseNotification';
export type PlanId = 'standard' | 'pro';
export const CHECKOUT_URLS: Record<PlanId, string> = {
  standard: 'https://checkout.luludigital.shop/cart/46371023913157:1',
  pro: 'https://checkout.luludigital.shop/cart/46371023880389:1'
};
export function SalesPage() {
  // The higher-priced PRO plan is preselected by default
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('pro');
  const handleScrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleBuy = () => {
    window.location.href = CHECKOUT_URLS[selectedPlan];
  };
  return <div className="min-h-screen bg-cream-50 font-sans text-navy-900" data-id="element-252">
      <TopBar data-id="element-253" />
      <Hero onScrollToPricing={handleScrollToPricing} data-id="element-254" />
      <Testimonials data-id="element-255" />
      <PainPoints data-id="element-256" />
      <Audience onScrollToPricing={handleScrollToPricing} data-id="element-257" />
      <Contents data-id="element-258" />
      <ComparisonTable data-id="element-259" />
      <Pricing selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} onBuy={handleBuy} data-id="element-260" />
      <ProPack data-id="element-261" />
      <Guarantee data-id="element-262" />
      <Faq data-id="element-263" />
      <FinalCta selectedPlan={selectedPlan} onBuy={handleBuy} data-id="element-264" />
      <Footer data-id="element-265" />
      <PurchaseNotification data-id="element-266" />
    </div>;
}